import { render, staticRenderFns } from "./fragrance-leaderboard.vue?vue&type=template&id=3862356a&"
import script from "./fragrance-leaderboard.vue?vue&type=script&lang=js&"
export * from "./fragrance-leaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports